type Attachment = {
  id: number
  fileName: string
  presignedUrl: string
  fileType: string
  attachmentType: string
}

type Quotation = {
  contractorName: string
  amount: string | number
  remark: string
  isAwarded: boolean
  attachments: Attachment[]
  dateCreated: string
  contractorId?: string | number
}

type PurchaseRequest = {
  purchaseRequestNumber: string | number
  attachments: Attachment[]
}

type PurchaseOrder = {
  purchaseOrderDtos: {
    attachments: Attachment[]
    retainAttachmentIds?: number[]
    purchaseOrderNumber: string
  }[]
  purchaseRequest: {
    attachments: Attachment[]
    retainAttachmentIds?: number[]
    purchaseRequestNumber: string
  }
}

export const handleValidateQuotationData = (quotationData: Quotation[]) => {
  if (quotationData.length === 0) {
    return true
  }
  return !quotationData.every(
    (quotation) =>
      quotation.contractorName && quotation.amount && quotation.attachments.length > 0
  )
}

export const handleValidateIsAwardedExist = (quotationData: Quotation[]) => {
  const isFound = quotationData.find(
    (quotation) => quotation.isAwarded === true,
  )
  return isFound ? false : true
}

export const handleValidatePurchaseRequestData = (
  purchaseRequestData: PurchaseRequest[],
) => {
  if (purchaseRequestData.length === 0) {
    return true
  }
  return !purchaseRequestData.every(
    (purchaseRequestData) => purchaseRequestData.purchaseRequestNumber,
  )
}

export const handleValidatePurchaseOrderData = (
  purchaseOrderData: PurchaseOrder[],
) => {
  let isEmpty = false
  purchaseOrderData.map((purchaseOrderData) => {
    if (purchaseOrderData.purchaseOrderDtos.length === 0) {
      isEmpty = true
    }

    if (!isEmpty) {
      isEmpty = !purchaseOrderData.purchaseOrderDtos.every(
        (purchaseOrderData) => purchaseOrderData.purchaseOrderNumber,
      )
    }
  })

  return isEmpty
}

export const handleStepperActive = (
  currentLayerId: number,
  currentTicketHolder: string,
) => {
  console.log('CURRENT LAYER ID', currentLayerId)
  console.log('CURRENT TICKET HOLDER', currentTicketHolder)
  if (currentLayerId === 14 && currentTicketHolder === 'DND Purchasing Admin') {
    return 3
  }

  if (currentLayerId === 15 && currentTicketHolder === 'GA Purchasing Staff') {
    return 3
  }
  return 1
}
